import { getProductPricing } from '../../utils';
import { useProductCustomer } from '../../contexts/ProductCustomerContext';
import { IProduct } from '@monofront/types';

export const useProductPricing = (
  product: Pick<
    IProduct,
    'price' | 'compare_at_price' | 'tags' | 'meta' | 'combination_product_data'
  >,
  quantity: number,
) => {
  const { isMalin: isCustomerMalin } = useProductCustomer();

  return getProductPricing(product, quantity, {
    isCustomerMalin,
  });
};
